module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module5-2.d5b659dd.jpg";